import { render, staticRenderFns } from "./tour-date-selector.vue?vue&type=template&id=1b8aaedc&scoped=true&"
import script from "./tour-date-selector.vue?vue&type=script&lang=js&"
export * from "./tour-date-selector.vue?vue&type=script&lang=js&"
import style0 from "./tour-date-selector.vue?vue&type=style&index=0&id=1b8aaedc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8aaedc",
  null
  
)

export default component.exports